export default "__VITE_ASSET__fCxUezDf__"